import React from 'react'

//components
import { LoadingSpinner } from 'thrive-components';
import SpotlightCard from '../spotlight/elements/SpotlightCard';

//hooks
import { useLatestFromThrive } from './LatestFromThrive.hooks';

//styles
import '../../../css/home/latest-from-thrive.scss';



const LatestFromThrive = () => {
    const { spotlightData, isLoading } = useLatestFromThrive();

    let content;

    if (isLoading) {
        content =   (
            <span className='loading-spotlight-data'>
                <LoadingSpinner />
            </span>
        );

    } else if (!spotlightData || spotlightData.items.length < 1) {
        content = (
            <span className='no-spotlight-data'>
                No Spotlight updates available.
            </span>
        );

    } else {
        content = (
            <>
                <div className='spotlight-hero'>
                    <SpotlightCard
                        key={spotlightData.items[0].id}
                        item={spotlightData.items[0]}
                    />
                </div>

                {spotlightData.items.length > 1 && (
                    <div className='spotlight-grid'>
                        {spotlightData.items.slice(1).map((item) => (
                            <SpotlightCard
                                key={item.id}
                                item={item}
                            />
                        ))}
                    </div>
                )}
            </>
        );
    }

    return (
        <div className='latest-from-thrive-container'>
            <h1 className='latest-from-thrive-header'>
                Latest From Thrive
            </h1>
            
            {content}
        </div>
    );
};

export default LatestFromThrive